import React from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslate } from "../../hooks/LanguageProvider";

interface ModalDeleteSiteProps {
    show: boolean;
    onHide: () => void;
    id_site: number | null;
    onSuccess?: () => void;
}

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ModalDeleteSite: React.FC<ModalDeleteSiteProps> = ({
    show,
    onHide,
    id_site,
    onSuccess,
}) => {
    const { translate } = useTranslate();

    const handleDelete = async () => {
        if (!id_site) return;


        try {
            const response = await fetch(
                `${backendUrl}/api/site/${id_site}`,
                { 
                  method: "DELETE",
                  credentials: "include"
                }
            );
            console.log("Response status:", response.status);
            if (!response.ok) {
                throw new Error(translate("Error deleting Site."));
            }

            const result = await response.json();
            console.log(result);

            toast.success(translate("Site deleted successfully!"), {
                position: "bottom-right",
                autoClose: 2400,
            });

            if (onSuccess) onSuccess();
            onHide();
        } catch (error) {
            console.error(error);
            toast.error(translate("Error deleting Site. Please try again."), {
                position: "bottom-right",
                autoClose: 2400,
            });
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{translate("Delete Site")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{translate("Are you sure you want to delete this site and all its programs?")}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {translate("Close")}
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                    {translate("Delete")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalDeleteSite;
